import { useTranslation } from 'react-i18next';
import { units } from './units';

export const useFormatTimeInterval = () => {
  const { t } = useTranslation();

  const formatTimeInterval = (amount: number, unit: keyof typeof units) => {
    let keySuffix: string;

    if (amount % 10 === 1 && amount % 100 !== 11) {
      keySuffix = '';
    } else if (
      [2, 3, 4].includes(amount % 10) &&
      ![12, 13, 14].includes(amount % 100)
    ) {
      keySuffix = '_plural';
    } else {
      keySuffix = '_many';
    }

    const label = t(`time.${unit}${keySuffix}`, {
      count: amount,
      ns: 'translation',
    });
    const milliseconds = amount * units[unit];

    return { label, value: String(milliseconds), amount, unit };
  };

  return formatTimeInterval;
};

type OptionsFilter = {
  minMilliseconds?: number;
  maxMilliseconds?: number;
  allowedUnits?: (keyof typeof units)[];
};

export const useTimeIntervalOptions = ({
  minMilliseconds = 0,
  maxMilliseconds,
  allowedUnits,
}: OptionsFilter = {}) => {
  const formatTimeInterval = useFormatTimeInterval();

  const getOptions = (v: string) => {
    const amount = parseInt(v);

    return (Object.keys(units) as (keyof typeof units)[])
      .filter((unit) => !allowedUnits || allowedUnits.includes(unit))
      .map((unit) => formatTimeInterval(amount, unit))
      .filter((option) => {
        const value = parseInt(option.value);
        return (
          value >= minMilliseconds &&
          (maxMilliseconds === undefined || value <= maxMilliseconds)
        );
      });
  };

  return getOptions;
};